export const slide60 = {
  id: 'slide60_fragments',
  initial: 'fragment1',
  states: {
    fragment1: {
      after: {
        1000: { target: '#slide60_fragments.fragment2' },
      },
      meta: {
        id: 'fragment1',
        name: 'message',
        content: {
          text: ' מה אתם קופצים? חכו רגע. תבדקי בדיוק על כמה ארטיקים מדובר.',
        },
      },
    },
    fragment2: {
      on: {
        WATCH_AUDIO: { target: '#slides.slide45' },
      },
      meta: {
        id: 'fragment2',
        name: 'audio_listener',
        content: {
          position: 7,
          event: 'WATCH_AUDIO',
          src: 'https://res.cloudinary.com/dcodkxpej/video/upload/v1710685257/Decision%20making%20game/girls/7.3_%D7%AA%D7%95%D7%93%D7%94_%D7%A2%D7%9C_%D7%94%D7%A2%D7%A6%D7%94_%D7%91%D7%93%D7%A7%D7%A0%D7%95_%D7%9B%D7%9E%D7%94_%D7%9E%D7%93%D7%95%D7%91%D7%A8_%D7%95%D7%9B%D7%9E%D7%94_%D7%99%D7%A9_%D7%9C%D7%A0%D7%95_%D7%9E%D7%A7%D7%95%D7%9D_%D7%95%D7%94%D7%95%D7%90_%D7%94%D7%A1%D7%9B%D7%99%D7%9D_%D7%A9%D7%A0%D7%A7%D7%A0%D7%94_%D7%A8%D7%A7_%D7%97%D7%9C%D7%A7_xqyrz6.mp3',
        },
      },
    },
  },
  meta: {
    id: 'slide60',
    section: '65f6bff57989236ea9a3a207',
    display: {
      backgroundColor: '',
      backgroundGradient:
        'linear-gradient(46.92deg, #F9ED32 -21.38%, #FBB040 180.02%)',
      backgroundImage: '',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-no-repeat',
      backgroundOpacity: 1,
      backgroundVideo: '',
      transition: 'slide',
      transitionSpeed: 'default',
      backgroundTransition: 'fade',
    },
    content: [],
    settings: {
      container: {
        backgroundColor: '#F5F5F5',
        display: 'end',
        heightPercentage: 0.77,
        header: {
          backgroundHeader: '#FFFFFF',
          title: 'הקומונה של רונה',
          type: 'chat',
          src: 'https://res.cloudinary.com/dcodkxpej/image/upload/v1710679982/Decision%20making%20game/girls/Oval_s83qad.svg',
        },
      },
    },
  },
};

export default slide60;
